module.exports = __webpack_public_path__ + "img/msg.82308deb.png";